import React from 'react';
import { Link } from 'react-router-dom';
import { Target, Anchor, Building2 } from 'lucide-react';

const Method = () => {
  return (
    <div className="min-h-screen pt-32">
      {/* Hero */}
      <section className="py-20">
        <div className="container-custom">
          <h1 className="heading-1 mb-8">THE GPS METHOD™</h1>
          <p className="body-large max-w-3xl">
            A psychologically grounded system for developing presence, internal structure, and professional readiness.
          </p>
        </div>
      </section>

      {/* Core Principles */}
      <section className="py-20 bg-card">
        <div className="container-custom">
          <h2 className="heading-2 mb-16 text-center">CORE PRINCIPLES</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            <div className="text-center">
              <div className="flex justify-center mb-6">
                <Anchor size={48} className="text-primary" />
              </div>
              <h3 className="heading-4 mb-4 text-primary">GROUNDING</h3>
              <p className="body-small">
                Establishing a stable internal base. Not relaxation—structural stability under pressure.
              </p>
            </div>
            <div className="text-center">
              <div className="flex justify-center mb-6">
                <Target size={48} className="text-primary" />
              </div>
              <h3 className="heading-4 mb-4 text-primary">PRESENCE</h3>
              <p className="body-small">
                Full psychological availability. Internal orientation, not external performance.
              </p>
            </div>
            <div className="text-center">
              <div className="flex justify-center mb-6">
                <Building2 size={48} className="text-primary" />
              </div>
              <h3 className="heading-4 mb-4 text-primary">SELF-STRUCTURE</h3>
              <p className="body-small">
                Developing internal architecture that supports sustained professional work.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Who It's For */}
      <section className="py-20">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto">
            <h2 className="heading-2 mb-12">WHO THIS IS FOR</h2>
            <div className="space-y-8">
              <div>
                <h3 className="heading-5 mb-3 text-primary">Professional Actors</h3>
                <p className="body-small text-secondary">
                  Those who need internal technique that functions under professional conditions—auditions, rehearsals, long-term projects.
                </p>
              </div>
              <div>
                <h3 className="heading-5 mb-3 text-primary">Coaches & Teachers</h3>
                <p className="body-small text-secondary">
                  Professionals developing their own practice or training others in presence-based work.
                </p>
              </div>
              <div>
                <h3 className="heading-5 mb-3 text-primary">Serious Practitioners</h3>
                <p className="body-small text-secondary">
                  Individuals committed to long-term development. This method requires time, discipline, and precision.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What It's Not */}
      <section className="py-20 bg-card">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto">
            <h2 className="heading-2 mb-12">WHAT THIS IS NOT</h2>
            <div className="space-y-6">
              <p className="body-medium">
                <span className="text-primary font-semibold">Not therapy.</span> This is a training method for professional practice, not clinical intervention.
              </p>
              <p className="body-medium">
                <span className="text-primary font-semibold">Not motivation.</span> There are no quick fixes, no hype, no shortcuts to readiness.
              </p>
              <p className="body-medium">
                <span className="text-primary font-semibold">Not surface technique.</span> This work develops internal architecture, not external tricks.
              </p>
              <p className="body-medium">
                <span className="text-primary font-semibold">Not for everyone.</span> The method is demanding. It requires commitment and seriousness.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20">
        <div className="container-custom text-center">
          <h2 className="heading-3 mb-8 text-secondary">READY TO STUDY THE METHOD?</h2>
          <Link to="/school" className="btn-primary inline-flex items-center">
            Explore Training Programs
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Method;